<template>
  <div 
    :class="{
      'custom-collection-content md:flex align-items-center': isCustomColectionCarousels,
      'collection-carousels__header container md:flex justify-between items-end text-center md:text-left': !isCustomColectionCarousels,
    }"
    >
    <h2 v-if="title">
      {{ title }}
    </h2>
    <p 
      v-if="description" 
      class="custom-desc"
    >
      {{ description }}
    </p>

    <template v-if="carousels.length > 1">
      <div 
        class="collection-carousels__buttons flex" 
        :class="{ 'custom-btn': isCustomColectionCarousels }"
      >
        <button
          v-for="carousel, index in carousels"
          :key="`carousel-btn-${index}`"
          class="collection-carousel__button"
          :class="{ 'collection-carousel__button--active': carousel.collectionHandle === activeCarousel.collectionHandle }"
          @click="changeCarousel(index)"
        >
          {{ carousel.title }}
        </button>
      </div>
    </template>
    <a 
      v-if="isCustomColectionCarousels"
      :href="`/collections/${activeCarousel.collectionHandle}`"
      class="collection-carousels__cta btn custom-cta-button desktop"
    >
      {{ activeCarousel.ctaText || ctaText || "Shop now" }}
    </a>
  </div>

  <div 
    :class="{
      'custom-collection-products' : isCustomColectionCarousels,
      'hide-usps': !showUsps
    }"
  >
    <vue-flickity
      :key="activeCarousel.collectionHandle"
      ref="carousel"
      class="collection-carousels__carousel collection-carousels__carousel--flickity"
      :options="{
        'prevNextButtons': true,
        'pageDots': false,
        'cellAlign': 'left'
      }"
    >
      <ProductItem
        v-for="product in activeCarousel.collectionProducts"
        :key="product.handle"
        :product="product"
      />
    </vue-flickity>
 
    <div
      :key="activeCarousel.collectionHandle"
      ref="carousel"
      class="collection-carousels__carousel collection-carousels__carousel--static"
    >
      <ProductItem
        v-for="product in activeCarousel.collectionProducts"
        :key="product.handle"
        :product="product"
      />
    </div>
  </div>

  <a
    v-if="activeCarousel.showCta"
    :href="`/collections/${activeCarousel.collectionHandle}`"
    class="collection-carousels__cta btn"
    :class="{ 'custom-cta-button mobile' : isCustomColectionCarousels}"
  >
    {{ activeCarousel.ctaText || ctaText }}
  </a>
</template>

<script>
import ProductItem from './product-item'
export default {
  components: {
    ProductItem
  },
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    ctaText: {
      type: String,
      default: null
    },
    isCustomColectionCarousels: {
      type: Boolean,
      default: false
    },
    carousels: {
      type: Array,
      default: null
    },
    showUsps: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeCarousel: { ...this.carousels[0] },
    }
  },
  mounted () {
    console.log("DATA::", this.title, this.isCustomColectionCarousels)
  },
  methods: {
    changeCarousel(index) {
      this.activeCarousel = this.carousels[index]
      this.updateJudgeMe()
      // this.$refs.carousel.destroy()
    },
    updateJudgeMe () {
      setTimeout(() => {
        window.jdgm?.customizeBadges?.()
      }, 300)
    },

  }
}
</script>
